'use client';

import { useTranslation } from 'react-i18next';

interface StatItem {
    value: number;
    suffix: string;
    labelKey: string;
}

export function StatsSection() {
    const { t } = useTranslation();

    const statsKeys = [
        'projects',
        'experience',
        'satisfaction',
        'technologies'
    ];

    return (
        <section className="mb-12 sm:mb-16">
            <div className="reveal-stagger grid grid-cols-2 gap-x-6 gap-y-10 border-t border-slate-200 pt-10 dark:border-slate-800 md:grid-cols-4">
                {statsKeys.map((key) => (
                    <div key={key} className="text-left">
                        <span data-count className="block text-5xl sm:text-6xl font-bold tracking-tight text-slate-900 dark:text-white">
                            {t(`HomeStats.items.${key}.value`)}
                        </span>
                        <p className="mt-3 text-[11px] font-bold uppercase tracking-[0.18em] text-slate-800 dark:text-slate-200">
                            {t(`HomeStats.items.${key}.label`)}
                        </p>
                        <p className="mt-1 text-xs text-slate-500 dark:text-muted-foreground">
                            {t(`HomeStats.items.${key}.subtext`)}
                        </p>
                    </div>
                ))}
            </div>
        </section>
    );
}
